// extracted by mini-css-extract-plugin
export default {"rootLayout":"App_rootLayout__AeXIV","contentLayout":"App_contentLayout__-ROiE"};